<template lang="pug">
  vm-prompt(@vm-cancel="close" @vm-accept="save" @vm-close="close" @vm-action="deleteRecordConfirm(form)" :vm-action="form.deleted_at" :vm-action-text="$t('strings.delete')" :vm-accept-text="$t('strings.accept')" :vm-cancel-text="$t('strings.cancel')" :vm-buttons-hidden="form.deleted_at" :vm-is-valid="!$v.form.$invalid" :vm-active="isModalVisible" :vm-title='getTitle')
    vm-row(vm-align="center" vm-type="flex" vm-justify="space-between" vm-w="12" v-shortcuts="[{ shortcut: [ 'enter', ], callback: save, push: true, focus: true, disabled: $v.form.$invalid },]")
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          vm-select(:placeholder='$t("branches.branch_placeholder")' :danger="$v.form.branch_origin_id.$invalid && $v.form.branch_origin_id.$model" :danger-text="$t('validation.required', { attribute: $t('branches.branch') })" v-model="form.branch_origin_id" :label='$t("branches.branch_origin")')
            vm-select-item(:key="index" :value="item.id" :text="item.name" v-for="(item,index) in branches")
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          vm-select(:placeholder='$t("branches.branch_placeholder")' :danger="$v.form.branch_destination_id.$invalid && $v.form.branch_destination_id.$model" :danger-text="$t('validation.required', { attribute: $t('branches.branch') })" v-model="form.branch_destination_id" :label='$t("branches.branch_destination")')
            vm-select-item(:key="index" :value="item.id" :text="item.name" v-for="(item,index) in branches")
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          vm-textarea(:placeholder='$t("transfers.comments_placeholder")' v-model="form.comments" :label='$t("transfers.comments")')
</template>

<script>
import ModalMixin1 from '@/mixins/ModalMixin1'
import { required } from 'vuelidate/lib/validators' // Ver documentacion
import { createNamespacedHelpers, mapGetters as configMapGetters } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('Transfers')

export default {
  name: 'ModalTransfers',
  mixins: [ModalMixin1],
  validations () {
    return {
      form: {
        branch_origin_id: {
          required
        },
        branch_destination_id: {
          required
        }
      }
    }
  },
  computed: {
    ...mapGetters(['isModalVisible', 'branches']),
    ...configMapGetters(['isSFS'])
  },
  watch: {
    async isModalVisible (value) {
      if (value && this.branches.length === 0) await this.getBranches()
      if (value && this.isAdd && !this.form.branch_destination_id && this.$auth.user().branch_id) { this.setDefault(this.$auth.user().branch_id) }
    }
  },
  methods: {
    ...mapActions([
      'addRecord',
      'editRecord',
      'setModalVisible',
      'getBranches',
      'sendErrorSameBranch'
    ]),
    save () {
      if (this.form.branch_destination_id != this.form.branch_origin_id) {
        this.saveRecord()
      } else {
        this.sendErrorSameBranch()
      }
    },
    setDefault (branch_id) {
      this.form = {
        branch_destination_id: branch_id
      }
    }
  }
}
</script>
